// src/pages/LoginPage.js
import React, { useEffect, useState } from 'react';
import { useNavigate } from 'react-router-dom';
import Logo from '../components/Logo';
import api from '../services/api';
import { useAuth } from '../context/AuthContext';
import { useSearchParams } from 'react-router-dom';
import { Button, Card, CardBody, FormControl, LayoutContainer, MessageBlock } from '../components/ui';
import '../styles/login.css';

const LoginPage = () => {
  const navigate = useNavigate();
  const { login } = useAuth();
  const [username, setUsername] = useState('');
  const [password, setPassword] = useState('');
  const [branchNumber, setBranchNumber] = useState('');
  const [rememberMe, setRememberMe] = useState(false);
  const [showPassword, setShowPassword] = useState(false);
  const [errorMessage, setErrorMessage] = useState('');

  const [searchParams] = useSearchParams();
  const [message, setMessage] = useState('');

  useEffect(() => {
    const queryMessage = searchParams.get('message');
    if (queryMessage === 'sesion_expirada') {
      setMessage('Tu sesión ha expirado. Por favor, inicia sesión nuevamente.');
    }
  }, [searchParams]);

  const handleLogin = async (e) => {
    e.preventDefault();
    try {
      const response = await api.post('/login', { username, password, branch_number: branchNumber });

      const { access_token, user, commerce, config } = response.data;
      const { id: channelId, name: commerceName, logo: commerceLogo, branch } = commerce;
      const { id: branchId, name: branchName } = branch;

      // Llamar al método login
      login(access_token, user, channelId, branchId, commerceName, branchName, commerceLogo, config);

      navigate('/');
    } catch (error) {
      console.error('Login error:', error.response?.data || error.message);
      setErrorMessage('Credenciales incorrectas. Por favor intenta de nuevo.');
    }
  };

  return (
    <div id="auth-left" className="rg-login">
      <LayoutContainer size="md" className="rg-login__container">
        <div className="auth-logo rg-login__logo">
          <a href="/">
            <Logo />
          </a>
        </div>

        <Card className="rg-login__card">
          <CardBody className="rg-login__card-body">
            <h1 className="auth-title rg-login__title">Portal Comercios</h1>

            <div className="rg-spacing-stack rg-login__alerts">
              {errorMessage && (
                <MessageBlock tone="error" title="Error de acceso">
                  {errorMessage}
                </MessageBlock>
              )}
              {message && (
                <MessageBlock tone="warning" title="Sesión">
                  {message}
                </MessageBlock>
              )}
            </div>

            <form onSubmit={handleLogin} className="rg-login__form rg-spacing-stack" noValidate>
              <FormControl
                id="branch-number"
                label="Número de sucursal"
                type="text"
                placeholder="Número de sucursal"
                value={branchNumber}
                onChange={(e) => setBranchNumber(e.target.value)}
                iconLeft={<i className="bi bi-shop" aria-hidden="true"></i>}
                autoComplete="organization"
              />

              <FormControl
                id="username"
                label="Usuario"
                type="text"
                placeholder="Usuario"
                value={username}
                onChange={(e) => setUsername(e.target.value)}
                iconLeft={<i className="bi bi-person" aria-hidden="true"></i>}
                autoComplete="username"
              />

              <FormControl
                id="password"
                label="Contraseña"
                type={showPassword ? 'text' : 'password'}
                placeholder="Contraseña"
                value={password}
                onChange={(e) => setPassword(e.target.value)}
                iconLeft={<i className="bi bi-shield-lock" aria-hidden="true"></i>}
                iconRight={
                  <button
                    type="button"
                    className="rg-login__password-toggle"
                    onClick={() => setShowPassword((prev) => !prev)}
                    aria-label={showPassword ? 'Ocultar contraseña' : 'Mostrar contraseña'}
                  >
                    <i className={`bi ${showPassword ? 'bi-eye-slash' : 'bi-eye'}`} aria-hidden="true"></i>
                  </button>
                }
                autoComplete="current-password"
              />

              <div className="rg-login__remember">
                <input
                  className="form-check-input rg-focusable"
                  type="checkbox"
                  checked={rememberMe}
                  onChange={() => setRememberMe(!rememberMe)}
                  id="remember-me"
                />
                <label className="form-check-label" htmlFor="remember-me">
                  Recordarme en esta computadora
                </label>
              </div>

              <Button type="submit" variant="primary" size="lg" fullWidth>
                Ingresar
              </Button>
            </form>
          </CardBody>
        </Card>
      </LayoutContainer>
    </div>
  );
};

export default LoginPage;
